import { render, staticRenderFns } from "./drop.vue?vue&type=template&id=6b87a172&"
import script from "./drop.vue?vue&type=script&lang=js&"
export * from "./drop.vue?vue&type=script&lang=js&"
import style0 from "./drop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports